﻿import { Component, ElementRef, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataTable } from "angular2-datatable";
import { DataService } from "../services/dataService";



@Component({
    selector: "jax-probationcomponent",
    templateUrl: "./probation.component.html"
})

export class Probationcomponent implements OnInit {
    public data;
    public probationStatus;
    public sortBy = "ProbationOfficerFirstName";
    public sortOrder = "asc";
    public rowsOnPage = 10;
    private userID: number;
    private currentUser: any;
    public totalRecord = 0;
    public isCompleted = false;
    public validationMessage="";
    @Input() caseId: number;


    public documentHistory: any = {};


    constructor(private dataService: DataService, private router: Router) {
    }

    public ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userID = this.currentUser.UserId;
        }

        this.isCompleted = false;
        this.validationMessage = "";

        this.dataService.get("casedetail/probation?caseId=" + this.caseId + "&userId=" + this.userID).subscribe(
            (resp) => {
                this.data = resp;
                this.isCompleted = true,
                    this.totalRecord = this.data.length;
            },
            (error) => {
                this.validationMessage = error.message;
                this.isCompleted = true;
            });


        this.dataService.get("casedetail/probationstatus?caseId=" + this.caseId + "&userId=" + this.userID).subscribe(
            (resp) => {
                this.probationStatus = resp;
                this.isCompleted = true;
            },
            (error) => {
                this.validationMessage = error.message;
                this.isCompleted = true;
            });
    }

    public onchange(pageEvent: any) {
        this.totalRecord = pageEvent.dataLength;
        this.rowsOnPage > 15 ? this.rowsOnPage = 10 : this.rowsOnPage = this.rowsOnPage;
    }
}
